import React from 'react';
import './index.css';
import TextToSpeech from './txtTospeech.js';


export default function Awards() {
  return (
    <div className="sectionComponent">
      <h1 id="awardh1">AWARDS</h1>
      <TextToSpeech
        inputText={
          'Awards. Women in Technology Scholarship. Awarded $7500 to aid in my pursuit of education and a career in technology. USC Undergraduate Research Apprenticeship Program. Awarded $3000 to pursue research in neuroscience. USC Summer Undergraduate Research Fund. Awarded $3000 to pursue research in neuroscience. USC QuestBridge Scholar, Awarded a scholarship to attend USC as a low-income student. USC Abrams Attridge Scholar. Awarded a scholarship to aid in my studies at USC.'
        }
      ></TextToSpeech>
      <dl>
        <dt>Women in Technology Scholarship</dt>
        <dd>Awarded $7500 to aid in my pursuit of education and a career in technology</dd>
        <dt>USC Undergraduate Research Apprenticeship Program</dt>
        <dd>Awarded $3000 to pursue research in neuroscience</dd>
        <dt>USC Summer Undergraduate Research Fund</dt>
        <dd>Awarded $3000 to pursue research in neuroscience</dd>
        <dt>USC QuestBridge Scholar</dt>
        <dd>Awarded a scholarship to attend USC as a low-income student</dd>
        <dt>USC Abrams Attridge Scholar</dt>
        <dd>Awarded a scholarship to aid in my studies at USC</dd>
      </dl>
    </div>
  );
}
